/**
 * Shared constants.
 */
const constants = {
  postingCategory: [
    { label: 'Unknown', value: '' },
    { label: 'Rooms & Shares', value: 'rooms-shares' },
    { label: 'Apts/Housing For Rent', value: 'apts-housing' },
    { label: 'Housing Swap', value: 'housing-swap' },
    { label: 'Office & Commercial', value: 'office-commercial' },
    { label: 'Parking & Storage', value: 'parking-storage' },
    { label: 'Real Estate - By Broker', value: 'real-estate-broker' },
    { label: 'Real Estate - By Owner', value: 'real-estate-owner' },
    { label: 'Sublets & Temporary', value: 'sublets-temporary' },
    { label: 'Vacation Rentals', value: 'vacation' }
  ],
  housingTypes: [
    { label: 'Unknown', value: '' },
    { label: 'Apartment', value: 'apartment' },
    { label: 'Condo', value: 'condo' },
    { label: 'Cottage/Cabin', value: 'cottage/cabin' },
    { label: 'Duplex', value: 'duplex' },
    { label: 'Flat', value: 'flat' },
    { label: 'House', value: 'house' },
    { label: 'In-Law', value: 'in-law' },
    { label: 'Loft', value: 'loft' },
    { label: 'Townhouse', value: 'townhouse' },
    { label: 'Manufactured', value: 'manufactured' },
    { label: 'Assisted Living', value: 'assisted living' },
    { label: 'Land', value: 'land' }
  ],
  airConditioning: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  contactBy: [
    { label: 'Auto-Detect', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  emailPolicy: [
    { label: 'Unknown', value: '' },
    { label: 'Show', value: 'show' },
    { label: 'Hide', value: 'hide' },
    { label: 'Anonymize', value: 'anonymize' }
  ],
  dogPolicy: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  catPolicy: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  evCharging: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  smokingPolicy: [
    { label: 'Unknown', value: null },
    { label: 'No Smoking', value: true },
    { label: 'Smoking Ok', value: false }
  ],
  wheelchairAccess: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  furnished: [
    { label: 'Unknown', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  laundry: [
    { label: 'Unknown', value: '' },
    { label: 'In Unit', value: 'w/d-in-unit' },
    { label: 'Hookups', value: 'w/d-hookups' },
    { label: 'In Building', value: 'laundry-in-building' },
    { label: 'On Site', value: 'laundry-on-site' },
    { label: 'None', value: 'none' }
  ],
  parking: [
    { label: 'Unknown', value: '' },
    { label: 'Carport', value: 'carport' },
    { label: 'Attached Garage', value: 'attached-garage' },
    { label: 'Detached Garage', value: 'detached-garage' },
    { label: 'Off-Street', value: 'off-street' },
    { label: 'Street', value: 'street' },
    { label: 'Valet', value: 'valet' },
    { label: 'None', value: 'none' }
  ],
  rentPeriod: [
    { label: 'Unknown', value: '' },
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ],
  propertyTypes: [
    { label: 'Unknown', value: '' },
    { label: 'Affordable', value: 'affordable' },
    { label: 'Apartment', value: 'apartment' },
    { label: 'Conventional', value: 'conventional' },
    { label: 'Lease-Up', value: 'lease-up' },
    { label: 'Military', value: 'military' },
    { label: 'Senior', value: 'senior' },
    { label: 'Single-Family', value: 'single-family' },
    { label: 'Student', value: 'student' }
  ],
  groupTypes: [
    { label: 'Reporting', value: 'reporting' },
    { label: 'Invoicing', value: 'invoicing' }
  ],
  groupReportSorting: [
    { label: 'Ad Count', value: 'count' },
    { label: 'Alphabetical', value: 'alpha' }
  ],
  emailReports: [
    { label: 'Daily', value: 'receives_daily_syndication_reports' },
    { label: 'Weekly', value: 'receives_weekly_week_reports' },
    { label: 'Monthly', value: 'receives_monthly_syndication_reports' }
  ],
  invoiceSummaries: [
    { label: 'Monthly', value: 'receives_monthly_summaries' },
    { label: 'Quarterly', value: 'receives_quarterly_summaries' },
    { label: 'Yearly', value: 'receives_yearly_summaries' }
  ],
  onDemandReportTypes: [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Custom', value: 'custom' }
  ],
  craigslistAccountStatus: [
    { label: 'Unknown', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ],
  status: [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
    { label: 'Onboarding', value: 'onboarding' },
    { label: 'Offboarding', value: 'offboarding' },
    { label: 'Pending', value: 'pending' },
    { label: 'Pre-Trial', value: 'pre-trial' },
    { label: 'Trial', value: 'trial' },
    { label: 'Invalid', value: 'invalid' },
    { label: 'Auto-Created', value: 'auto-created' }
  ],
  features: [
    { label: 'Posting', value: 'Automated Posting' },
    { label: 'Renews', value: 'Automatic Ad Renewal' },
    { label: 'Price Updating', value: 'Price Updating' },
    { label: 'Phone', value: 'Lead Tracking (phone)' },
    { label: 'Email', value: 'Lead Tracking (email)' },
    { label: 'Redirect Links', value: 'Lead Tracking (website)' },
    { label: 'Landing Pages', value: 'Landing Pages' },
    { label: 'Scheduled Posting', value: 'Scheduled Posting' },
    { label: 'Posting Service', value: 'Posting Service' },
    { label: 'Premium Service', value: 'Premium Service' }
  ],
  corporation: [
    { label: 'Canada', value: 'Canada' },
    { label: 'US', value: 'US' }
  ],
  billingFrequency: [
    { label: 'Unknown', value: null },
    { label: 'Monthly', value: 1 },
    { label: 'Quarterly', value: 3 },
    { label: 'Semi-Annually', value: 6 },
    { label: 'Annually', value: 12 }
  ],
  billingMethods: [
    { label: 'Unknown', value: '' },
    { label: 'Email', value: 'email' },
    { label: 'Nexus', value: 'nexus' },
    { label: 'QuickBooks Online', value: 'quickbooks-online' },
    { label: 'RealPage Opstech', value: 'realpage-opstech' },
    { label: 'Snail Mail', value: 'snail-mail' },
    { label: 'Stripe', value: 'stripe' },
    { label: 'VendorAccess', value: 'vendoraccess' },
    { label: 'VendorCafe', value: 'vendorcafe' }
  ],
  setUpFee: [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ],
  companyCategory: [
    { label: 'Unknown', value: '' },
    { label: 'Broker', value: 'broker' },
    { label: 'Flat-Rate', value: 'flat-rate' },
    { label: 'Multi-Family', value: 'multi-family' },
    { label: 'Single-Family', value: 'single-family' }
  ],
  companyLeadSource: [
    { label: 'Unknown', value: '' },
    { label: 'Ad - PPC', value: 'ad-ppc' },
    { label: 'Ad - Publication', value: 'ad-publication' },
    { label: 'Association', value: 'association' },
    { label: 'Cold - Phone Call', value: 'cold-phone' },
    { label: 'Cold - Email', value: 'cold-email' },
    { label: 'Event/Conference', value: 'event-conference' },
    { label: 'List (Purchased)', value: 'list-purchased' },
    { label: 'Phone Call (Incoming)', value: 'phone-call-incoming' },
    { label: 'Referral - Client', value: 'referral-client' },
    { label: 'Referral - Other', value: 'referral-other' },
    { label: 'Social - LinkedIn', value: 'social-linkedin' },
    { label: 'Social - Twitter', value: 'social-twitter' },
    { label: 'Web Search (Organic)', value: 'web-search' },
    { label: 'Website - Contact Us', value: 'website-contact-us' },
    { label: 'Website - Demo', value: 'website-demo' },
    { label: 'Website - sales@rooof.com', value: 'website-sales@rooof.com' },
    { label: 'Website - Trial', value: 'website-trial' }
  ],
  reasonForCancel: [
    { label: 'Budget', value: 'budget' },
    { label: 'Change of Management', value: 'change-of-management' },
    { label: 'Craigslist - Flagging', value: 'craigslist-flagging' },
    { label: 'Craigslist - Fraud', value: 'craigslist-fraud' },
    { label: 'Craigslist - Not Performing', value: 'craigslist-not-performing' },
    { label: 'Low Engagement', value: 'low-engagement' },
    { label: 'Merger', value: 'merger' },
    { label: 'Natural Disaster', value: 'natural-disaster' },
    { label: 'No Vacancy', value: 'no-vacancy' },
    { label: 'Other', value: 'other' },
    { label: 'Posting Fee', value: 'posting-fee' },
    { label: 'Price Increase', value: 'price-increase' },
    { label: 'Sold', value: 'sold' },
    { label: 'Subscription Change', value: 'subscription-change' },
    { label: 'Upgrading Product', value: 'subscription-upgrade' },
    { label: 'Downgrading Product', value: 'subscription-downgrade' },
    { label: 'Switching to Bake Extra Cookies', value: 'switching-to-bec' },
    { label: 'Switching to Competitor (Unknown)', value: 'switching-to-unknown' },
    { label: 'Switching to Knock', value: 'switching-to-knock' },
    { label: 'Switching to Manual Posting', value: 'switching-to-manual' },
    { label: 'Switching to RapidSoft', value: 'switching-to-rapidsoft' },
    { label: 'Switching to Weblisters', value: 'switching-to-weblisters' },
    { label: 'Unable to Perform Service', value: 'unable-to-perform-service' },
    { label: 'Unhappy', value: 'unhappy' },
    { label: 'Unknown', value: 'unknown' },
    { label: 'Unpaid Invoices', value: 'unpaid-invoices' }
  ],
  agreementTypes: [
    { label: 'Master Invoice Only', value: 'Master Invoice Only' },
    { label: 'Property Invoice Only', value: 'Property Invoice Only' },
    { label: 'Master and Property Invoices Allowed', value: 'Master and Property Invoices Allowed' }
  ],
  propertyBillingTypes: [
    { label: 'Part of Master Invoice', value: 'included_in_master' },
    { label: 'Invoiced Separately', value: 'invoiced_separately' }
  ],
  timezones: [
    'US/Alaska',
    'US/Central',
    'US/Eastern',
    'US/Hawaii',
    'US/Mountain',
    'US/Pacific'
  ],
  postingDayOptions: [
    { label: 'Monday', value: 'Mon' },
    { label: 'Tuesday', value: 'Tue' },
    { label: 'Wednesday', value: 'Wed' },
    { label: 'Thursday', value: 'Thu' },
    { label: 'Friday', value: 'Fri' }
  ],
  states: [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District Of Columbia', value: 'DC' },
    { label: 'Federated States Of Micronesia', value: 'FM' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Palau', value: 'PW' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' }
  ],
  provinces: [
    { label: 'Nunavut', value: 'NU' },
    { label: 'Newfoundland and Labrador', value: 'NL' },
    { label: 'Northwest Territories', value: 'NT' },
    { label: 'Yukon', value: 'YT' },
    { label: 'British Columbia', value: 'BC' },
    { label: 'Alberta', value: 'AB' },
    { label: 'Saskatchewan', value: 'SK' },
    { label: 'Manitoba', value: 'MB' },
    { label: 'Ontario', value: 'ON' },
    { label: 'Quebec', value: 'QC' },
    { label: 'New Brunswick', value: 'NB' },
    { label: 'Nova Scotia', value: 'NS' },
    { label: 'Prince Edward Island', value: 'PE' }
  ],
  currencies: [
    { label: 'USD', value: 'USD' },
    { label: 'CAD', value: 'CAD' }
  ],
  config: [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false }
  ],
  organizationType: [
    { label: 'Unknown', value: '' },
    { label: 'Owner', value: 'owner' },
    { label: 'Fee-managed', value: 'fee-managed' },
    { label: 'Combination', value: 'combination' }
  ],
  autoRenewOverride: [
    { label: 'No Override', value: '{}' },
    { label: 'Force Auto-Renew On', value: JSON.stringify({ optionsPageConfig: { defaultOptions: { craigslistEnableRenew: true } } }) },
    { label: 'Force Auto-Renew Off', value: JSON.stringify({ optionsPageConfig: { defaultOptions: { craigslistEnableRenew: false } } }) }
  ],
  showOrHide: [
    { label: 'Show', value: true },
    { label: 'Hide', value: false }
  ],
  titleSetting: [
    { label: 'Let PostEngine auto-generate titles', value: 'no_titles' },
    { label: 'Randomly pick between stored and auto-generated titles', value: 'alternate_titles' },
    { label: 'Randomly pick from stored titles only', value: 'stored_only' },
    { label: 'Let me pick from stored titles every time', value: 'user_choose' }
  ],
  unableToPostReasons: [
    { value: 'Client Website Issue' },
    { value: 'Content Issue' },
    { value: 'Missing Buttons' },
    { value: 'No Pricing/Availability' },
    { value: 'Service Note - No Action Required' },
    { value: 'Other' }
  ]
}

/**
 * Handsontable dropdown elements only allow
 * an array of primitives as the source,
 * rather than key-value pairs.
 */
const htConstants = {}
for (const key in constants) {
  htConstants[key] = constants[key].map(obj => obj.value)
}

/**
 * Enums for each of the constants using the label as the key
 * e.g. enums.groupTypes.INVOICING
 */
const enums = {}
for (const key in constants) {
  enums[key] = {}
  for (const obj of constants[key]) {
    if (obj.label) {
      const enumKey = obj.label.toUpperCase().replace(/[^A-Z0-9]+/ig, '_')
      enums[key][enumKey] = obj.value
    }
  }
}

/**
 * Finds the constant using its value and returns the label.
 * e.g. getConstantLabelByValue('provinces', 'NU') = 'Nunavut'
 * @param {String} key
 * @param {*} value
 * @returns {String}
 */
function getConstantLabelByValue (key, value) {
  const obj = constants[key].find(obj => obj.value === value)
  return obj && obj.label
}

export { constants, htConstants, enums, getConstantLabelByValue }
